export default {
      id: "i-work-time-usage",
      viewBox: "0 0 155 155",
      url: __webpack_public_path__ + "img/sprite.svg#i-work-time",
      toString: function () {
        return this.url;
      }
    }